export const UPLOAD_DOCUMENT: string = 'UPLOAD_DOCUMENT';

export const SET_UPLOADED_DOCUMENT: string = 'SET_UPLOADED_DOCUMENT';

export const FILE_LIMIT = 5242880;

export const FILE_TYPE = 'application/pdf';

export const DEFAULT_DOCUMENT_TYPE = 'PV';

export const RESET_UPLOAD_DOCUMENT_STORE = 'RESET_UPLOAD_DOCUMENT_STORE';

export const SET_DOCUMENT_ID: string = 'SET_DOCUMENT_ID';

export const REQUEST_GET_REPORTS_POLICY: string = 'REQUEST_GET_REPORTS_POLICY';
export const SET_DOCUMENTUM_ID = 'SET_DOCUMENTUM_ID';
